import FavoriteToggleContainer from './containers/FavoriteToggleContainer'

export default FavoriteToggleContainer
